import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ModalUser from "./modalUser";
import { useConf } from "../../context/account/paramsAccount";
import { apiPostDeconnect, apiPostWToken } from "../../api/apiPost";
import logoPsy from "../../images/logo/synapsy.svg";
import { useError } from "../../context/erreur/erreurContext";
import { useOfflineMode } from "../../context/horsLigne/modeHorsLigneContext";
import { handleActivateOfflineMode, handleDesactivateOfflineMode } from "../../functions/HorsLigne/activeornotHl";
import { loadModeHorsligne } from "../../functions/HorsLigne/loadmodeHL";
import { redirection } from "../../functions/redirect";
import { Switch } from "@progress/kendo-react-inputs";
import { Storage } from "@capacitor/storage";
import { Capacitor } from "@capacitor/core";

export function Header({ handleModalUser }: any) {
    const isNativeApp = Capacitor.isNativePlatform();

    const [currentPage, setCurrentPage] = useState("");
    const [valueCurrentPage, setValueCurrentPage] = useState("");
    const { ifOffLineMode, toggleOfflineMode } = useOfflineMode();
    const [hash, sethash] = useState("")
    const [isOffLine, setIsOffLine] = useState(false)
    const { conf, setConf } = useConf()
    const { showError } = useError();
    const navigate = useNavigate();
    const [listePresta, setListePresta]: any = useState(undefined)
    useEffect(() => {
        if (conf?.conf?.ifOffLineMode) {
            setIsOffLine(conf?.conf?.ifOffLineMode)
        }
        else {
            setIsOffLine(false)
        }
    }, [conf?.conf?.ifOffLineMode])
    // Function to map pathname to page title
    const getPageTitle = (pathname: string): string => {
        if (pathname.includes("/planning")) return "Planning";
        if (pathname.includes("/connexion")) return "Connexion";
        if (pathname.includes("/parametre")) return "Paramètres";
        if (pathname.includes("/retour-prestation")) return "Retour de prestation";
        if (pathname.includes("/affiche-presta")) return "Prestation";
        if (pathname.includes("/mode-hors-ligne")) return "Mode Hors Ligne";
        return "";
    };

    const handleBack = () => {
        setCurrentPage("");
        setValueCurrentPage("");
        window.history.back();
    };

    useEffect(() => {
        const pathname = window.location.pathname;
        setCurrentPage(pathname);
        setValueCurrentPage(getPageTitle(pathname));
    }, [window.location.pathname]);

    const handleModal = () => {
        const setModal = handleModalUser.setModalUser;
        setModal(!handleModalUser.modalUser);
    };
    const deconnexionUser = async () => {
        const id = { id: conf.user.id, url: conf.user.url };
        apiPostDeconnect('/posts/user-logout', conf.token, showError)
        await Storage.remove({ key: 'active_user' });
    };
    useEffect(() => {
        loadModeHorsligne('prestaHl', conf)
            .then(data => {
                if (data) {
                    const entetes = data.map((item: any) => item?.entete);
                    if (entetes) {
                        setListePresta(entetes)
                    }
                } else {
                    setListePresta(undefined)
                }
            })
            .catch(error => console.error('Erreur lors du chargement des données hors ligne :', error));
    }, [conf])
    useEffect(() => {
        loadModeHorsligne('localPassword', conf)
            .then(data => {
                if (data) {
                    sethash(data)
                } else {
                    sethash("")
                }
            })
            .catch(error => console.error('Erreur lors du chargement des données hors ligne :', error));
    }, [])

    const checkPresta = () => {
        loadModeHorsligne('prestaHl', conf)
            .then(data => {
                if (data) {
                    if (data?.length > 0) {
                        const entetes = data.map((item: any) => item?.entete);
                        if (entetes) {
                            handleActivateOfflineMode(setConf, conf, toggleOfflineMode)
                            setListePresta(entetes)
                        }
                    } else {
                        handleDesactivateOfflineMode(setConf, conf, false)

                    }
                } else {
                    setListePresta(undefined)
                    if (conf.conf.ifOffLineMode === true) {
                        redirection(navigate, "/mode-hors-ligne")
                    }
                }
            })
            .catch(error => console.error('Erreur lors du chargement des données hors ligne :', error));
    }
    return (
        <div className="header_background">
            {currentPage !== "/" && (
                <svg
                    onClick={handleBack}
                    className="svgBack"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 320 512"
                >
                    <path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z" />
                </svg>
            )}
            {(conf.user.isConnected === false || window.location.pathname === "/") && (
                <img className="logoPSY" src={logoPsy} />
            )}
            <span className="title">{valueCurrentPage}</span>
            {
                isNativeApp ?
                    <div className="containerRight">
                        <p onClick={() => { checkPresta() }}>Mode hors ligne</p>
                        <Switch onChange={() => { listePresta === undefined || listePresta?.length === 0 || hash === "" ? checkPresta() : handleActivateOfflineMode(setConf, conf, toggleOfflineMode) }} checked={conf?.conf?.ifOffLineMode} />
                        <ModalUser
                            isConnected={conf.user.isConnected}
                            modalIsOpen={handleModalUser.modalUser}
                            openModal={handleModal}
                            deconnexion={deconnexionUser}
                        />
                    </div> : <div className="containerRight">
                    </div>
            }

        </div>
    );
}
